<template>
  <v-chip
    v-if="team"
    :color="color"
    :text-color="textColor"
    :to="includeLink ? '/departments/' + team.id : null"
    @click="$emit('click')"
    :outlined="outlined"
    :close="close"
    @click:close="$emit('close')"
    :class="{ 'pl-0': team.logoUrl, 'pl-1': !team.logoUrl }"
    :small="dense"
    :disabled="disabled"
  >
    <team-avatar
      :team="team"
      :color="color"
      :textColor="textColor"
      :iconSize="dense ? 15 : 20"
    ></team-avatar>
    {{ team.fullName || team.name }}
  </v-chip>
</template>

<script>
export default {
  name: "TeamChip",
  props: {
    team: { type: Object },
    includeLink: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    color() {
      if (this.outlined) {
        return "secondarytext";
      } else if (this.selected) {
        return "secondary";
      }
      return "background";
    },
    textColor() {
      if (this.selected) {
        return "white";
      }
      return "secondarytext";
    }
  }
};
</script>

<style lang="scss" scoped>
.v-chip ::v-deep .v-chip__content .v-avatar {
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
}

.v-chip.v-size--small ::v-deep .v-chip__content .v-avatar {
  height: 24px !important;
  width: 24px !important;
  min-width: 24px !important;
}
</style>
